import { useEffect, useState } from 'react';
import { useFeatureFlag } from '@harnessio/ff-react-client-sdk';

const DEFAULT_FAILSAFE_MS = 5000;

// Distinguishes "Harness hasn't finished initializing yet" (returns undefined,
// briefly) from "Harness is unreachable" (returns undefined indefinitely, since
// the SDK's `ready` event never fires on auth failure). Only falls back to
// `false` once failsafeMs has elapsed with no resolution.
export function useFeatureFlagWithFailsafe(
  flagIdentifier: string,
  failsafeMs: number = DEFAULT_FAILSAFE_MS
): boolean | undefined {
  const rawValue = useFeatureFlag(flagIdentifier) as boolean | undefined;
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (rawValue !== undefined) return;
    const timer = setTimeout(() => setTimedOut(true), failsafeMs);
    return () => clearTimeout(timer);
  }, [rawValue, failsafeMs]);

  if (rawValue !== undefined) return rawValue;
  return timedOut ? false : undefined;
}
